import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreFontainesSurSaone() {
  useEffect(() => {
    document.title = 'Fontaines-sur-Saône Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Fontaines-sur-Saône Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Fontaines-sur-Saône. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Fontaines-sur-Saône, dépannage fenêtres Fontaines-sur-Saône, vitrier Fontaines-sur-Saône');
    }
    
    const linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) {
      linkCanonical.setAttribute('href', 'https://fenetres-lyon.com/reparation-fenetre-fontaines-sur-saone');
    }
    
    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '45.8364;4.8456');
    }
    
    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Fontaines-sur-Saône');
    }
    
    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-69');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CityHero 
        cityName="Fontaines-sur-Saône"
        imageSeq="fontaines-sur-saone-hero-024"
      />
      <Services />
      <Testimonials />
      <Contact />
      <FAQ />
      <Footer />
    </div>
  );
}
